"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.LabelText = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../../typography");
var LabelTextSize = (_a = {},
    _a['small'] = design_system_theme_1.FontSizes.fontSize16,
    _a['medium'] = design_system_theme_1.FontSizes.fontSize18,
    _a);
exports.LabelText = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, theme = _a.theme;
    return ({
        color: theme.colors.text.primary,
        sizes: [LabelTextSize[$size]],
        forwardedAs: 'label',
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var LabelHintText = (0, styled_components_1.default)(exports.LabelText).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.text.secondary,
        forwardedAs: 'span',
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var RequiredAsterisk = (0, styled_components_1.default)(exports.LabelText).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.text.error,
        forwardedAs: 'span',
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 2px;\n"], ["\n  margin-left: 2px;\n"])));
/**
 * A Label used for describing form inputs.
 */
var Label = function (_a) {
    var labelText = _a.labelText, labelHint = _a.labelHint, htmlFor = _a.htmlFor, required = _a.required, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.LabelText, { "$size": size, htmlFor: htmlFor, className: className },
            labelText,
            ' ',
            required ? (react_1.default.createElement(RequiredAsterisk, { "$size": size, "aria-hidden": "true" }, "*")) : null),
        labelHint ? react_1.default.createElement(LabelHintText, { "$size": size }, labelHint) : null));
};
exports.Label = Label;
var templateObject_1, templateObject_2, templateObject_3;
